module.exports = new __parcel__URL__("traits_text.ef6c0dc9.png").toString();